import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'
import { isUserProfileCompleted } from './selectors'

const withUserData = connect(state => ({
  isProfileCompleted: isUserProfileCompleted(state)
}))

const withButtonClickHandler = withProps(props => ({
  onCompleteProfileButtonClick(e) {
    e && e.preventDefault()
    const { history, isProfileCompleted } = props
    const destination = !!isProfileCompleted
      ? '/myprofile'
      : '/myprofile/complete-profile'
    history.push(destination)
  }
}))

export default compose(withUserData, withButtonClickHandler)



// WEBPACK FOOTER //
// ./src/services/session/register-success.js